import Dialog, { DialogProps } from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import  { useRef,useEffect,useState } from "react";
import {Box, Typography, Modal, Button, TextField, InputLabel, Select, MenuItem, FormControl, List, ListItem, ListItemText} from '@mui/material';
import { Link } from 'react-router-dom';


function ApplicantStatementModal(props: any) {
    const isOpen = props.isOpen;
    const [scroll, setScroll] = useState<DialogProps['scroll']>('paper');
    const descriptionElementRef = useRef<HTMLElement>(null);
    
    return (
    <>



            <Dialog
        open={isOpen}
        onBackdropClick={props.onCloseModal}
        fullWidth={true}
        maxWidth={"lg"}
        scroll={scroll}
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
      >
        <DialogTitle id="scroll-dialog-title" className='text-center'>
            Applicant Statement
        </DialogTitle>
        <DialogContent dividers={scroll === 'paper'}>
          <DialogContentText
            id="scroll-dialog-description"
            ref={descriptionElementRef}
            tabIndex={-1}
          >
            <strong>Verification of Content</strong>
            <br/><br/>
            I declare that the statements contained herein are true to the best of my knowledge and belief and do agree to pay any
            surcharges applicable under the Company rules which are necessitated by inaccurate statements. I declare that no persons
            other than those listed in this application regularly operate the vehicle(s) described in this application. I declare that none of
            the vehicles listed in this application will be used to carry persons or property for a fee or any commercial purpose.
            <br/><br/>
            <strong>Notice of Insurance Practices</strong>
            <br/><br/>
            I understand that to calculate an accurate price for my insurance, the Company may obtain information from third parties,
            such as consumer reporting agencies that provide driving and claims histories. The Company may also obtain information
            about the vehicle(s) to be insured. This information will be used to underwrite my insurance and provide an accurate quote. I
            understand that the premium on any policy issued on the basis of this application may be adjusted as the result of these
            reports. The Company may obtain new or updated information to calculate my renewal premium or service my insurance. I
            may access information about me and correct it if inaccurate. In some cases, the law permits the Company to disclose the
            information it collects without authorization. However, the Company will not share personal information with nonaffiliated
            companies for their marketing purposes without consent. Complete details are in the Company's Privacy Policy, which will be
            provided with this insurance policy and upon request.
            <br/><br/>
            <strong>Acknowledgement and Agreement</strong>
            <br/><br/>
            If I make my initial payment by credit card, the coverage afforded under this policy is conditioned on payment to the Company
            by the card issuer. I understand that if the Company is unable to collect my initial payment from the card issuer, the Company
            shall be deemed not to have accepted the payment and this policy shall be void. I also understand that if I authorize a credit
            card transaction for any payment other than the initial payment, this policy will be subject to cancellation for nonpayment of
            premium if the Company is unable to collect payment from the card issuer. The Company is deemed "unable to collect" in the
            following instances: (1) when I reach my credit limit on my credit card and the card issuer refuses the charge; (2) when the card
            issuer cancels or revokes my credit card; or (3) when the card issuer does not pay the Company, for any reason whatsoever,
            upon the Company's request.
            <br/><br/>
            I understand that a service charge will be assessed to the balance due on my policy if any check offered in payment is not
            honored by my bank or other financial institution.
            <br/><br/>
            <strong>Fraud Statement</strong>
            <br/><br/>
            <strong>OK WARNING:</strong> Any person who knowingly, and with intent to injure, defraud or deceive any insurer, makes any claim for the
            proceeds of an insurance policy containing any false, incomplete or misleading information is guilty of a felony.
            <br/><br/>
            <strong>TX WARNING:</strong> ANY PERSON WHO KNOWINGLY PRESENTS A FALSE OR FRAUDULENT CLAIM FOR PAYMENT OF A LOSS, OR
            KNOWINGLY PRESENTS FALSE INFORMATION IN AN APPLICATION FOR INSURANCE MAY BE GUILTY OF A CRIME AND MAY BE
            SUBJECT TO FINES AND CONFINEMENT IN STATE PRISON.
            <br/><br/>
            <strong>Other Charges</strong>
            <br/><br/>
            I agree to pay the installment fees shown on my billing statement that become due during the policy term and each renewal
            policy term in accordance with the payment plan I have selected. I understand that the amount of these fees may change upon
            policy renewal or if I change my payment plan. Any change in the amount of installment fees will be reflected on my payment
            date.
            <br/><br/>
            <strong>Applicant Signature</strong>
            <br/><br/>
            I represent that I am the person identified as the named insured and the first driver in the Rated Drivers section of this
            application. I acknowledge and agree to the statements contained within this application.
            I also acknowledge and agree that by checking the box on the screen and clicking "Pay Now", I am electronically signing this
            application, which will have the same legal effect as the execution of this document by a written signature and shall be valid
            evidence of my intent and agreement to be bound by its terms.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={props.onCloseModal}>Close</Button>
        </DialogActions>
      </Dialog>
    </>);
}

export default ApplicantStatementModal;